<template>
  <vue-snotify></vue-snotify>
</template>


<script>
import Vue from "vue";
import { mapState } from "vuex";

import Snotify from "vue-snotify";
import { SnotifyPosition } from "vue-snotify";

Vue.use(Snotify);

export default {
  watch: {
    "alert.time": function() {
      this.$snotify.create({
        title: null,
        body: this.alert.message,
        config: {
          position: SnotifyPosition.rightTop,
          type: this.alert.notifyType,
          showProgressBar: false,
        /*   html:`<div class="snotifyToast__title"><b>Html Bold Title</b></div>
  <div class="snotifyToast__body"><i>Html</i> <b>toast</b> <u>content</u></div> ` */
        }
      });

      if (this.alert.type == "alert-success") {
        this.$root.$emit("bv::hide::modal", this.$root.currentModal);
      }
    }
  },
  computed: {
    ...mapState({ alert: state => state.alert })
  }
};
</script>
